const PARAMETER_DEFINITIONS = {
  turbidity: {
    label: 'Turbidity',
    unit: 'NTU',
    description: 'Turbidity in NTU',
  },
  chlorophyllA: {
    label: 'Chlorophyll a',
    unit: 'mg/m3',
    description: 'Chlorophyll a in mg/m3',
  },
  dissolvedOxygen: {
    label: 'Dissolved oxygen',
    unit: 'mg/L',
    description: 'Dissolved oxygen in mg/L',
  },
  seaSurfaceSalinity: {
    label: 'Sea Surface Salinity',
    unit: 'PSU',
    description: 'Sea Surface Salinity in PSU',
  },
  eColi: {
    label: 'E. coli',
    unit: 'cfu/100ml',
    description: 'E. coli in cfu/100ml',
  },
  enterococci: {
    label: 'Enterococci',
    unit: 'cfu/100ml',
    description: 'Enterococci in cfu/100ml',
  },
  ph: {
    label: 'pH',
    unit: '',
    description: 'pH',
  },
  nitratesNo3: {
    label: 'Nitrates NO3',
    unit: 'mg/l',
    description: 'Nitrates NO3 in mg/l',
  },
  phosphatePo4: {
    label: 'Phosphate PO4',
    unit: 'mg/l',
    description: 'Phosphate PO4 in mg/l',
  },
  riverinePressureIndex: {
    label: 'Riverine Pressure Index',
    unit: '',
    description: 'Riverine Pressure index',
  },
  seaSurfaceTemperature: {
    label: 'Sea Surface Temperature',
    unit: 'K',
    description: 'Sea Surface Temperature in K',
  },
  seaWaterVelocity: {
    label: 'Sea Water Velocity',
    unit: 'm/s',
    description: 'Sea Water Velocity in m/s',
  },
  oceanMixedLayerThickness: {
    label: 'Ocean Mixed Layer Thickness',
    unit: 'm',
    description: 'Ocean mixed layer thickness in m',
  },
  rainfall: {
    label: 'Total precipitation',
    unit: 'mm',
    description: 'Total precipitation in mm',
  },
  industrialIntensity: {
    label: 'Industrial intensity unit',
    unit: 'empl/km2',
    description: 'Industrial intensity unit in empl/km2',
  },
  bod5: {
    label: '5-day Biochemical Oxygen Demand',
    unit: 'mg/l',
    description: '5-day Biochemical Oxygen Demand in mg/l',
  },
  cod: {
    label: 'Chemical Oxygen Demand',
    unit: 'mg/l',
    description: 'Chemical Oxygen Demand in mg/l',
  },
  totalSuspendedSolids: {
    label: 'Total Suspended Solids',
    unit: 'mg/l',
    description: 'Total Suspended Solids in mg/l',
  },
  totalPhosphorus: {
    label: 'Total Phosphorus',
    unit: 'mg/l',
    description: 'Total Phosphorus in mg/l',
  },
  ammoniumNitrogen: {
    label: 'Ammonium nitrogen',
    unit: 'mg/l',
    description: 'Ammonium nitrogen in mg/l',
  },
  totalNitrogen: {
    label: 'Total Nitrogen',
    unit: 'mg/l',
    description: 'Total Nitrogen in mg/l',
  },
};

const CONTRIBUTING_PARAMETERS_BY_INDICATOR = {
  humanHealthIndex: [
    'turbidity',
    'chlorophyllA',
    'dissolvedOxygen',
    'seaSurfaceSalinity',
    'eColi',
    'enterococci',
    'ph',
    'nitratesNo3',
    'phosphatePo4',
    'riverinePressureIndex',
    'seaSurfaceTemperature',
  ],
  animalHealthIndex: [
    'seaWaterVelocity',
    'oceanMixedLayerThickness',
    'ph',
    'turbidity',
    'chlorophyllA',
    'dissolvedOxygen',
    'seaSurfaceSalinity',
  ],
  environmentalHealthIndex: [
    'rainfall',
    'seaSurfaceTemperature',
    'seaSurfaceSalinity',
    'industrialIntensity',
    'bod5',
    'cod',
    'totalSuspendedSolids',
    'totalPhosphorus',
    'ammoniumNitrogen',
    'riverinePressureIndex',
    'totalNitrogen',
    'dissolvedOxygen',
    'ph',
    'turbidity',
    'chlorophyllA',
  ],
};

const CONTRIBUTING_PARAMETER_OPTIONS = [
  { id: 'humanHealthIndex', label: 'Human health' },
  { id: 'animalHealthIndex', label: 'Animal health' },
  { id: 'environmentalHealthIndex', label: 'Environmental health' },
];

export {
  CONTRIBUTING_PARAMETER_OPTIONS,
  CONTRIBUTING_PARAMETERS_BY_INDICATOR,
  PARAMETER_DEFINITIONS,
};
